// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3wxDn","title":"Info_title__3LDdv","links":"Info_links__2EN9q","link":"Info_link__21J-a","logo":"Info_logo__2rQIx"};